export const EventName = {
    compile: {
        completed: 'compile.completed',
        started: 'compile.started'
    },
    did: {
        action: 'did.action'
    },
    gem: {
        changed: 'gem.changed'
    },
    ide: {
        canvas: {
            event_counts: 'ide.canvas.event_counts',
            operation: 'ide.canvas.operation'
        },
        code_regen: 'ide.code_regen',
        compilation: 'ide.compilation',
        copilot: {
            request: 'ide.copilot.request'
        },
        data: {
            loaded: 'ide.data.loaded'
        },
        fabric: {
            connection: {
                connected: 'ide.fabric.connection.connected',
                disconnected: 'ide.fabric.connection.disconnected',
                started: 'ide.fabric.connection.started'
            }
        },
        gem: {
            code_generation: 'ide.gem.code_generation',
            compilation: 'ide.gem.compilation'
        },
        job: {
            opened: 'ide.job.opened',
            save: 'ide.job.save'
        },
        knowledge_graph: {
            lineage_query: 'ide.knowledge_graph.lineage_query'
        },
        pipeline: {
            code_generation: 'ide.pipeline.code_generation',
            opened: 'ide.pipeline.opened',
            run_snapshot_saved: 'ide.pipeline.run_snapshot_saved',
            schedule: {
                changed: 'ide.pipeline.schedule.changed'
            }
        },
        project: {
            opened: 'ide.project.opened',
            save: 'ide.project.save'
        },
        run: 'ide.run',
        sandbox: {
            acquisition: 'ide.sandbox.acquisition',
            usage: 'ide.sandbox.usage'
        },
        server: {
            connected: 'ide.server.connected'
        },
        session: {
            codegen_completed: 'ide.session.codegen_completed',
            compilation_done: 'ide.session.compilation_done',
            initialize_received: 'ide.session.initialize_received',
            initialize_sent: 'ide.session.initialize_sent',
            project_usable: 'ide.session.project_usable'
        },
        upload: {
            rejected: 'ide.upload.rejected'
        }
    },
    metadata: {
        entity: {
            mutation: 'metadata.entity.mutation'
        },
        git: {
            pull_request: 'metadata.git.pull_request'
        },
        graphql: {
            operation: 'metadata.graphql.operation'
        },
        release: {
            created: 'metadata.release.created',
            deployment: 'metadata.release.deployment'
        },
        search: {
            query: 'metadata.search.query'
        }
    },
    metagraph: {
        api: {
            call: 'metagraph.api.call'
        },
        git: {
            operation: 'metagraph.git.operation',
            pr_merge_completed: 'metagraph.git.pr_merge_completed'
        }
    },
    orchestrator: {
        interims: {
            completed: 'orchestrator.interims.completed'
        },
        pipeline: {
            run: 'orchestrator.pipeline.run'
        }
    },
    pipeline: {
        created: 'pipeline.created',
        scheduled: 'pipeline.scheduled'
    },
    project: {
        created: 'project.created'
    },
    run: {
        cleanup: 'run.cleanup',
        execute: 'run.execute',
        file_handoff: 'run.file_handoff',
        file_sync: 'run.file_sync',
        oauth_sync: 'run.oauth_sync',
        plan: 'run.plan',
        query: {
            firstResponse: 'run.query.firstResponse'
        },
        sandbox_acquire: 'run.sandbox_acquire',
        sandbox_initialize: 'run.sandbox_initialize',
        started: 'run.started'
    },
    runtime: {
        error: 'runtime.error'
    },
    sandbox: {
        activeCount: 'sandbox.activeCount',
        allocated: 'sandbox.allocated',
        created: 'sandbox.created',
        ready: 'sandbox.ready'
    },
    ui: {
        add: {
            new: {
                node: 'ui.add.new.node'
            }
        },
        ai: {
            suggestion_shown: 'ui.ai.suggestion_shown'
        },
        analysis: {
            entity: {
                creation: {
                    successful: 'ui.analysis.entity.creation.successful'
                }
            },
            modified: 'ui.analysis.modified',
            opened: 'ui.analysis.opened',
            run: {
                completed: 'ui.analysis.run.completed',
                started: 'ui.analysis.run.started'
            }
        },
        billing: {
            plan_changed: 'ui.billing.plan_changed',
            upgradeToEnterprise: 'ui.billing.upgradeToEnterprise',
            upgradeToPro: 'ui.billing.upgradeToPro'
        },
        blocking: {
            spinner: 'ui.blocking.spinner'
        },
        copilot: {
            agent: {
                autoRun: {
                    start: 'ui.copilot.agent.autoRun.start',
                    success: 'ui.copilot.agent.autoRun.success'
                },
                inspectData: {
                    start: 'ui.copilot.agent.inspectData.start'
                },
                messageFeedback: {
                    submit: 'ui.copilot.agent.messageFeedback.submit'
                },
                v4: {
                    feedback: {
                        downvote: 'ui.copilot.agent.v4.feedback.downvote',
                        upvote: 'ui.copilot.agent.v4.feedback.upvote'
                    },
                    response: 'ui.copilot.agent.v4.response',
                    user: {
                        prompt: {
                            send: 'ui.copilot.agent.v4.user.prompt.send'
                        }
                    }
                }
            },
            ask: {
                ai: 'ui.copilot.ask.ai'
            },
            code_applied: 'ui.copilot.code_applied',
            fix: 'ui.copilot.fix',
            suggesstion: {
                accept: 'ui.copilot.suggesstion.accept'
            }
        },
        create: {
            dataset: 'ui.create.dataset'
        },
        data: {
            loaded: 'ui.data.loaded'
        },
        data_mapping: {
            end: 'ui.data_mapping.end',
            start: 'ui.data_mapping.start'
        },
        expression: {
            view: {
                toggle: 'ui.expression.view.toggle'
            }
        },
        fabric: {
            connection: {
                attempt_failed: 'ui.fabric.connection.attempt_failed',
                auto_attach_skipped: 'ui.fabric.connection.auto_attach_skipped',
                connected: 'ui.fabric.connection.connected',
                disconnected: 'ui.fabric.connection.disconnected',
                retries_exhausted: 'ui.fabric.connection.retries_exhausted',
                started: 'ui.fabric.connection.started'
            },
            connection_tested: 'ui.fabric.connection_tested',
            entity: {
                creation: {
                    successful: 'ui.fabric.entity.creation.successful'
                }
            }
        },
        gem: {
            action: 'ui.gem.action',
            close: {
                dialog: 'ui.gem.close.dialog'
            },
            mode: {
                toggle: 'ui.gem.mode.toggle'
            },
            open: {
                dialog: 'ui.gem.open.dialog'
            },
            save: {
                dialog: 'ui.gem.save.dialog'
            },
            too: {
                complex: 'ui.gem.too.complex'
            }
        },
        ide: {
            pipeline: {
                add: {
                    new: {
                        node: 'ui.ide.pipeline.add.new.node'
                    }
                },
                replay: {
                    end: 'ui.ide.pipeline.replay.end',
                    item: {
                        new: 'ui.ide.pipeline.replay.item.new'
                    },
                    start: 'ui.ide.pipeline.replay.start'
                }
            }
        },
        interactive: {
            componentLevel: {
                run: 'ui.interactive.componentLevel.run'
            },
            full: {
                run: 'ui.interactive.full.run'
            },
            run: {
                cancelRequested: 'ui.interactive.run.cancelRequested',
                codegen: {
                    completed: 'ui.interactive.run.codegen.completed'
                },
                compile: {
                    completed: 'ui.interactive.run.compile.completed'
                },
                completed: 'ui.interactive.run.completed',
                compute: {
                    ready: 'ui.interactive.run.compute.ready'
                },
                firstResult: 'ui.interactive.run.firstResult',
                submission: {
                    completed: 'ui.interactive.run.submission.completed',
                    started: 'ui.interactive.run.submission.started'
                }
            }
        },
        interim: {
            received: 'ui.interim.received'
        },
        job: {
            entity: {
                creation: {
                    successful: 'ui.job.entity.creation.successful'
                }
            },
            opened: 'ui.job.opened'
        },
        metadata: {
            create: {
                fabric: 'ui.metadata.create.fabric'
            },
            ui: {
                page: {
                    load: 'ui.metadata.ui.page.load'
                }
            }
        },
        modified: {
            component: 'ui.modified.component'
        },
        onboarding: {
            ds: {
                create: 'ui.onboarding.ds.create'
            },
            end: 'ui.onboarding.end',
            fabric: {
                create: 'ui.onboarding.fabric.create',
                update: 'ui.onboarding.fabric.update'
            },
            home: {
                flowType: 'ui.onboarding.home.flowType'
            },
            pipeline: {
                envInfo: 'ui.onboarding.pipeline.envInfo',
                run: 'ui.onboarding.pipeline.run'
            },
            project: {
                create: 'ui.onboarding.project.create'
            },
            questionnaire: {
                end: 'ui.onboarding.questionnaire.end'
            }
        },
        page: {
            callSummary: 'ui.page.callSummary',
            dbsignup: {
                createPasswordSuccess: 'ui.page.dbsignup.createPasswordSuccess'
            },
            load: 'ui.page.load',
            resetPassword: {
                ResetPasswordButtonClicked: 'ui.page.resetPassword.ResetPasswordButtonClicked'
            },
            signin: {
                login_attempt: 'ui.page.signin.login_attempt',
                passwordLanding: 'ui.page.signin.passwordLanding',
                signinLandingPage: 'ui.page.signin.signinLandingPage'
            },
            signup: {
                CreatePasswordButtonClicked: 'ui.page.signup.CreatePasswordButtonClicked',
                CreateTeamButtonClicked: 'ui.page.signup.CreateTeamButtonClicked',
                OtpLandingPage: 'ui.page.signup.OtpLandingPage',
                UserProfileSubmitButtonClicked: 'ui.page.signup.UserProfileSubmitButtonClicked',
                VerifyOTPButtonClicked: 'ui.page.signup.VerifyOTPButtonClicked',
                databricksLandingPage: 'ui.page.signup.databricksLandingPage',
                step: {
                    completed: 'ui.page.signup.step.completed',
                    otp: 'ui.page.signup.step.otp',
                    password: 'ui.page.signup.step.password',
                    signup: 'ui.page.signup.step.signup',
                    userProfile: 'ui.page.signup.step.userProfile'
                }
            }
        },
        pipeline: {
            code_generation: 'ui.pipeline.code_generation',
            entity: {
                creation: {
                    successful: 'ui.pipeline.entity.creation.successful'
                }
            },
            opened: 'ui.pipeline.opened',
            schedule: {
                changed: 'ui.pipeline.schedule.changed'
            },
            view: {
                toggle: 'ui.pipeline.view.toggle'
            }
        },
        project: {
            entity: {
                creation: {
                    successful: 'ui.project.entity.creation.successful'
                }
            },
            opened: 'ui.project.opened'
        },
        run: {
            job: 'ui.run.job'
        },
        runtime: {
            error: 'ui.runtime.error'
        },
        session: {
            compile_failed: 'ui.session.compile_failed',
            compile_finish: 'ui.session.compile_finish',
            connect: 'ui.session.connect',
            data_load: 'ui.session.data_load',
            did_open: 'ui.session.did_open',
            editable: 'ui.session.editable',
            metadata_loaded: 'ui.session.metadata_loaded',
            open_click: 'ui.session.open_click',
            pipeline_show: 'ui.session.pipeline_show',
            project_usable: 'ui.session.project_usable',
            sandbox_ready: 'ui.session.sandbox_ready'
        },
        show: {
            the: {
                preview: 'ui.show.the.preview'
            }
        },
        sql: {
            ide: {
                component: {
                    add: 'ui.sql.ide.component.add'
                },
                model: {
                    add: 'ui.sql.ide.model.add'
                },
                source: {
                    add: 'ui.sql.ide.source.add',
                    connection: {
                        add: 'ui.sql.ide.source.connection.add'
                    }
                }
            }
        },
        template: {
            gallery_viewed: 'ui.template.gallery_viewed',
            industry_selected: 'ui.template.industry_selected',
            previewed: 'ui.template.previewed',
            used: 'ui.template.used'
        },
        transpiler: {
            import: {
                transpilation: {
                    failed: 'ui.transpiler.import.transpilation.failed',
                    start: 'ui.transpiler.import.transpilation.start',
                    success: 'ui.transpiler.import.transpilation.success'
                }
            }
        },
        upgrade: {
            plan: {
                user: {
                    start: 'ui.upgrade.plan.user.start'
                }
            }
        }
    }
};
